import React, { Component } from 'react';
import { Menu, Layout, message, Input, Select, Image } from 'antd';
import { SearchOutlined, AppstoreOutlined } from '@ant-design/icons';
import { NavLink } from 'react-router-dom';
import styles from './index.module.scss';
import fsLogo from '../../assets/images/logo/img_piclogo.png';
import fsTextLogo from '../../assets/images/logo/img_textlogo.png';
import searchIcon from '../../assets/images/icon_search.svg';

const { Sider } = Layout;
const { SubMenu, Item } = Menu;

class SideMenu extends Component {
  constructor(props) {
    super(props);
    this.hasMounted = true;
    this.menuObj = [];

    this.state = {
      openKeys: [], // 默认展开的侧边栏项
    };
  }

  componentDidMount() {
    const { history } = this.props;
    const { pathname: curPath } = history.location;
    this.setOpenKeys(curPath);
    history.listen(({ pathname: nextPathname }) => {
      if (!this.hasMounted) return;
      this.setOpenKeys(nextPathname);
    });
    this.getMenu(this.props.sideMenu);
  }
  componentWillUnmount() {
    this.hasMounted = false;
  }
  getMenu = (sidemenu) => {
    sidemenu.forEach((menu) => {
      if (menu.children) {
        this.getMenu(menu.children);
      } else {
        this.menuObj.push(menu);
      }
    });
  };
  setOpenKeys = (pathname) => {
    const [, ...keys] = pathname.split('/');
    const { openKeys } = this.state;
    const newOpenKeys = keys.reduce((sum, curr, i) => {
      sum.push(sum[i - 1] ? `${sum[i - 1]}/${curr}` : `/${curr}`);
      return sum;
    }, []);
    // 点击子菜单收起
    if (
      newOpenKeys.length === 2 &&
      newOpenKeys[0] === openKeys[0] &&
      newOpenKeys[1] === openKeys[1]
    ) {
      this.setState({
        openKeys: [newOpenKeys[0]],
      });
      // 当点击主菜单时如果已展开则收起
    } else if (
      // 三级菜单 丰食后台有三级路由和四级路由 所以点击三级路由时不清空openKeys，解决三级路由重复点击会导致侧边栏展开收起问题
      (newOpenKeys.join('') === openKeys?.join?.('') &&
        newOpenKeys.length !== 3 &&
        newOpenKeys.length !== 4) ||
      (newOpenKeys.length === 1 && newOpenKeys[0] === openKeys[0])
    ) {
      this.setState({
        openKeys: [],
      });
    } else {
      this.setState({
        openKeys: newOpenKeys,
      });
    }
  };
  onOpenChange = (openKeys) => {
    // openKeys.slice(-1)
    this.setState({ openKeys });
  };
  onNoPrivilege = () => {
    message.info('升级高级版可享用此功能');
  };
  isElementInViewport = () => {
    const rect = this.activeRef?.getBoundingClientRect();
    return (
      rect?.top >= 0 &&
      rect?.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    );
  };
  searchMenu = (value) => {
    const { history } = this.props;
    this.onOpenChange(value);
    history.push(value);
    if (!this.isElementInViewport()) {
      this.activeRef?.scrollIntoView({ behavior: 'smooth' });
    }
  };
  render() {
    const { sideMenu, payNum, goodsNum, shopType, isPolymer } = this.props;
    const { openKeys } = this.state;

    const subMenu = (top) => {
      // 二级菜单项提醒标志
      const showTopRemind =
        (top.path === '/order' && payNum > 0) ||
        (top.path === '/goods' && goodsNum > 0 && shopType === 'sub');
      const iconClass = `${top.path.slice(1)}`;
      return (
        <SubMenu
          onTitleClick={(e) => {
            this.setOpenKeys(e.key);
          }}
          key={top.path}
          className="root"
          title={
            <>
              <span className={`${iconClass} ${styles.icon}`}></span>
              <span>{top.name}</span>
              {showTopRemind && <span className="red-dot" />}
            </>
          }
        >
          {/* sub.children.map((child) => subMenu(child)) */}
          {top.children.map((sub) => {
            // 子菜单项提醒标志
            const showSubRemind =
              sub.path === '/goods/manage/list' && goodsNum > 0 && shopType === 'sub';
            return sub.view ? (
              sub.children ? (
                <SubMenu
                  key={sub.path}
                  title={<span>{sub.name}</span>}
                  className="sub"
                  onTitleClick={(e) => {
                    this.setOpenKeys(e.key);
                  }}
                >
                  {sub.children.map((child) => (
                    <Item key={child.path}>
                      <NavLink
                        to={child.path}
                        activeClassName="active"
                        ref={(ref) => {
                          this.activeRef = ref;
                        }}
                      >
                        <span>
                          {isPolymer
                            ? this.props.polymerDefine[child.path] || child.name
                            : child.name}
                        </span>
                        {/* {showSubRemind && <span className="red-dot" />} */}
                      </NavLink>
                    </Item>
                  ))}
                </SubMenu>
              ) : (
                <Item key={sub.path}>
                  <NavLink
                    to={sub.path}
                    activeClassName="active"
                    ref={(ref) => {
                      this.activeRef = ref;
                    }}
                  >
                    <span>
                      {isPolymer ? this.props.polymerDefine[sub.path] || sub.name : sub.name}
                    </span>
                    {showSubRemind && <span className="red-dot" />}
                  </NavLink>
                </Item>
              )
            ) : (
              <Item key={sub.path}>
                <a data-no-privilege onClick={this.onNoPrivilege}>
                  <span>
                    {isPolymer ? this.props.polymerDefine[sub.path] || sub.name : sub.name}
                  </span>
                </a>
              </Item>
            );
          })}
        </SubMenu>
      );
    };
    return (
      <>
        <NavLink to="/welcome" className={styles.sideLogo}>
          <img className={styles.imgLogo} src={fsLogo} alt="" />
          <img className={styles.imgText} src={fsTextLogo} alt="" />
          {/* <span>丰食后台</span> */}
        </NavLink>
        <div className={styles.serchDiv}>
          {/* <Input.Search onSearch={this.searchMenu} placeholder={`输入导航栏名称`} enterButton /> */}
          <Select
            onSelect={this.searchMenu}
            showSearch
            width={200}
            style={{ width: '150px' }}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            placeholder="输入导航栏名称"
            allowClear
            suffixIcon={
              <img
                src={searchIcon}
                alt=""
                style={{ height: '16px', width: '16px', marginTop: '-2px' }}
              />
            }
          >
            {this.menuObj.map((menu) => (
              <Select.Option value={menu.path} key={menu.path}>
                {menu.name}
              </Select.Option>
            ))}
          </Select>
        </div>

        <Menu
          theme="dark"
          mode="inline"
          openKeys={openKeys}
          onChange={this.onOpenChange}
          onClick={(e) => {
            this.setOpenKeys(e.key);
          }}
          defaultSelectedKeys={[location.hash.slice(1)]}
          className={styles.menuStyle}
        >
          {sideMenu.map((top) => {
            const page = top.path.slice(1);
            const iconClass = `menu-item-icon icon icon-${page}`;
            const icon =
              typeof top.icon === 'string' ? (
                <img className="menu-item-icon" src={top.icon} alt="menu-icon" />
              ) : (
                top.icon || <i className={iconClass} />
              );
            if (top.view) {
              return !top.children ? (
                <Item key={top.path}>
                  <NavLink
                    to={top.path}
                    activeClassName="active"
                    ref={(ref) => {
                      this.activeRef = ref;
                    }}
                  >
                    {/* {icon} */}
                    <span>{top.name}</span>
                  </NavLink>
                </Item>
              ) : (
                subMenu(top)
              );
            }
            return null;
          })}
        </Menu>
      </>
    );
  }
}

export default SideMenu;
